import { Controller } from '@hotwired/stimulus';

/* stimulusFetch: 'lazy' */
export default class extends Controller {
    static targets = ['content', 'error', 'success', 'form', 'send'];

    async submit(event) {
        event.preventDefault();
        this.errorTarget.classList.add('hidden');

        try {
            const data = new FormData(event.target);

            // Do a bit of work to convert the entries to a plain JS object
            const value = Object.fromEntries(data.entries());
            this.sendTarget.setAttribute('disabled', 'disabled');
            const response = await fetch(event.target.action, {
                method: event.target.method,
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(value),
            });

            if (response.ok) {
                await response.json(); // Assuming you might use the JSON response later
                document.getElementById('spinner').remove();

                this.formTarget.classList.add('!hidden');
                this.successTarget.classList.remove('hidden');
            } else {
                const error = await response.json();
                this.sendTarget.removeAttribute('disabled');
                document.getElementById('spinner').remove();

                if (error.message) this.errorTarget.innerText = error.message;
                else
                    this.errorTarget.innerText =
                        'An unexpected error occurred. Please try again.';
                this.errorTarget.classList.remove('hidden');
            }
        } catch (error) {
            // This catch block handles network errors or issues with response.json() itself
            this.sendTarget.removeAttribute('disabled');
            document.getElementById('spinner').remove();
            console.error('Fetch error:', error);

            this.errorTarget.innerText =
                'An unexpected error occurred. Please try again.';
            this.errorTarget.classList.remove('hidden');
        }
    }
}
